import React from "react";
import { useLocation } from "react-router-dom";
import {
  Tabs,
  TabList,
  Tab,
  Flex,
  Image,
  Box,
} from "@chakra-ui/react";

const panels = [
  { title: "SIGNS AND SYMPTOMS", path: "/signs-and-symptoms" },
  { title: "GENES", path: "/genes" },
  { title: "METHODS", path: "/methods" },
  { title: "DISCLAIMER", path: "/disclaimer" },
  { title: "ABOUT US", path: "/about-us" },
  { title: "PUBLICATIONS", path: "/publications" },
  { title: "CONTACT US", path: "/contact-us" },
];

const urlMapping = {
  "/signs-and-symptoms": "/signs-and-symptoms",
  "/genes": "/genes",
  "/methods": "/methods",
  "/disclaimer": "/disclaimer",
  "/about-us": "/about-us",
  "/publications": "/publications",
  "/contact-us": "/contact-us",
};

const Navbar = () => {
  const location = useLocation();

  const handleTabChange = (index) => {
    const newPath = panels[index].path;
    const destination = urlMapping[newPath] || newPath;
    window.location.href = destination;
  };

  const currentTabIndex = panels.findIndex((panel) =>
    location.pathname.startsWith(panel.path)
  );

  return (
    <>
      <Box
        mb={8}
        px={{ base: 2, sm: 6, md: 10 }}
        py={{ base: 6, md: 8 }}
      >
        <Flex
          direction={{ base: "column", lg: "row" }}
          align="center"
          justify="center"
          gap={{ base: 6, lg: 12 }}
          width="100%"
        >
          <Flex
            flex={{ base: "0 0 auto", lg: "1 1 0" }}
            justify={{ base: "center", lg: "flex-end" }}
            minW={0}
            width={{ base: "100%", lg: "auto" }}
          >
            <Image
              src="/logo1.png"
              alt="MDSGene"
              maxH={{ base: "48px", md: "56px" }}
              objectFit="contain"
            />
          </Flex>
          <Image
            src="/logo1.svg"
            alt="GP2 Global Parkinson's Genetics Program"
            width={{ base: "360px", md: "440px" }}
            maxW="100%"
            height="auto"
            flexShrink={0}
            objectFit="contain"
          />
          <Flex
            flex={{ base: "0 0 auto", lg: "1 1 0" }}
            justify={{ base: "center", lg: "flex-start" }}
            minW={0}
            width={{ base: "100%", lg: "auto" }}
          >
            <Image
              src="/uni-luebeck-logo.png"
              alt="Universität zu Lübeck"
              maxH={{ base: "44px", md: "52px" }}
              maxW={{ base: "220px", md: "280px" }}
              objectFit="contain"
            />
          </Flex>
        </Flex>
      </Box>
      <Tabs
        index={currentTabIndex === -1 ? 0 : currentTabIndex}
        onChange={handleTabChange}
        mb={8}
        variant="brand-pill"
      >
        <TabList flexWrap="wrap" gap={2} justifyContent="center">
          {panels.map((panel) => (
            <Tab key={panel.path} as="a" href={panel.path}>
              {panel.title}
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </>
  );
};

export default Navbar;
